import React, { Component, Fragment } from 'react'
import { debounce } from 'lodash-es'

export default class MediaQuery extends Component {
  constructor (props) {
    super(props)

    this.state = this.getScreenSpecs()

    this.updateScreenSpecs = this.updateScreenSpecs.bind(this)
    this.debouncedUpdateScreenSpecs = debounce(this.updateScreenSpecs, 200)
  }

  componentDidMount () {
    this.updateScreenSpecs()
    window.addEventListener('resize', this.debouncedUpdateScreenSpecs)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.debouncedUpdateScreenSpecs)
  }

  getScreenSpecs () {
    const screenWidth = window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth

    const screenHeight = window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
    return { screenWidth, screenHeight }
  }
  updateScreenSpecs () {
    const { screenWidth, screenHeight } = this.getScreenSpecs()
    this.setState({ screenWidth, screenHeight })
  }

  render () {
    const { children } = this.props
    const { screenWidth, screenHeight } = this.state

    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, { screenWidth, screenHeight })
    )

    return <Fragment>{childrenWithProps}</Fragment>
  }
}
